import { toast } from "react-toastify";

const servicesAction = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  FETHING: "FETHING",

  success: messages => {
    messages !== "" &&
      toast.success(messages, {
        position: "top-right",
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    return {
      type: servicesAction.SUCCESS,
      resType: "success",
      messages: messages,
      show: true,
      isFetching: false
    };
  },

  error: messages => {
    messages !== "" &&
      toast.error(messages, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    return {
      type: servicesAction.ERROR,
      resType: "error",
      messages: messages,
      show: true,
      isFetching: false
    };
  },

  fetching: () => ({
    type: servicesAction.FETHING,
    isFetching: true
  })
};

export default servicesAction;
